import { render } from "./FpAccordion.vue?vue&type=template&id=35676078"
import script from "./FpAccordion.vue?vue&type=script&lang=js"
export * from "./FpAccordion.vue?vue&type=script&lang=js"

import "./FpAccordion.vue?vue&type=style&index=0&id=35676078&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__